import React from 'react';
import './Modal.css';
import approvePlanIcon from "../../assets/images/approvePlanIcon.svg";
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyCenterText from '../designSystem/BodyExtraSmallRegular';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const ApprovePlanModal = ({ isVisible, onClose, onApproveClick, isLoading }) => {
    const [loading, setLoading] = React.useState(false);

    const handleApprove = async () => {
        setLoading(true);
        try {
            await onApproveClick();
        } catch (error) {
            console.error("Error approving:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        isVisible && (
            <div className="modal-backdrop">
    <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <LoadingOverlay isVisible={loading} />
        <div className={loading ? 'blur' : ''}>
            <div className='content-container'>
                            <img src={approvePlanIcon} />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Approve Plan' />
                            <BodyCenterText
                                color='#384153'
                                text='Are you sure you want to approve this monthly plan? Your decision will finalize the review for this employee.'
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                        >
                            <p className="button-text">Cancel</p>
                        </button>
                        <button className='primary-button' onClick={handleApprove} disabled={loading}>
                            <p className="button-text save">Approve</p>
                        </button>

                    </div>
                </div>
            </div>
        )
    );
};

export default ApprovePlanModal;
